import { render, staticRenderFns } from "./StoriesFullScreen.vue?vue&type=template&id=1cd4e853&scoped=true&"
import script from "./StoriesFullScreen.vue?vue&type=script&lang=js&"
export * from "./StoriesFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./StoriesFullScreen.vue?vue&type=style&index=0&id=1cd4e853&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4e853",
  null
  
)

component.options.__file = "StoriesFullScreen.vue"
export default component.exports